import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=7a0cfe98&scoped=true&"
import script from "./DataTable.vue?vue&type=script&lang=js&"
export * from "./DataTable.vue?vue&type=script&lang=js&"
import style0 from "./DataTable.vue?vue&type=style&index=0&id=7a0cfe98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0cfe98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/nc21docker/apps/health/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a0cfe98')) {
      api.createRecord('7a0cfe98', component.options)
    } else {
      api.reload('7a0cfe98', component.options)
    }
    module.hot.accept("./DataTable.vue?vue&type=template&id=7a0cfe98&scoped=true&", function () {
      api.rerender('7a0cfe98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/general/DataTable.vue"
export default component.exports